export default {
  TITULO: 'Dados do Advogado',
  NOME: 'Nome',
  TELEFONE: 'Telefone',
};
